// EXAMPLE wellbeing actions — the only fixture data left in this module.
//
// Every indicator on the dashboard now comes from /admin/fatigue/*. Actions do
// not: PEAK-179 (FM-14) is still blocked on how they are generated, who owns a
// status and what "closed" means, so persisting them would mean guessing the
// model. These illustrate the impact/ease framing and are labelled as examples
// wherever they are rendered — they are not tied to the real cohorts above them.

import type { FatigueAction } from './types';

export const EXAMPLE_ACTIONS: FatigueAction[] = [
  {
    id: 'act-1',
    title: 'Cap consecutive night shifts on the highest-CDI team',
    description:
      'Sustained night sequencing is usually the dominant CDI driver. Cap consecutive nights and insert a recovery day.',
    impact: 5,
    ease: 3,
    owner: 'Operations lead',
    dueDate: '2026-09-07',
    status: 'in_progress',
    notes: 'Example only — rota review cannot be tracked until shift capture ships (PEAK-169).',
  },
  {
    id: 'act-2',
    title: 'Reduce overtime exposure where rest windows are shortest',
    description:
      'Remove discretionary overtime for two weeks on the teams with the highest load–readiness misalignment.',
    impact: 4,
    ease: 4,
    owner: 'Logistics manager',
    dueDate: '2026-09-04',
    status: 'todo',
  },
  {
    id: 'act-3',
    title: 'Add a mid-shift recovery break on the highest-LRM team',
    description: 'Insert an additional rest break on the days where load runs furthest ahead of readiness.',
    impact: 3,
    ease: 5,
    owner: 'Site supervisor',
    dueDate: '2026-09-02',
    status: 'todo',
  },
  {
    id: 'act-4',
    title: 'Watch teams with elevated but stable circadian disruption',
    description: 'No schedule change yet — keep on watch and re-assess in two weeks against the same window.',
    impact: 2,
    ease: 5,
    owner: 'Wellbeing partner',
    dueDate: '2026-09-11',
    status: 'todo',
  },
  {
    id: 'act-5',
    title: 'Hold load flat on any red-tier team',
    description:
      'Sustained high FED and LRM together: hold load flat and prioritise rest and controls until readiness recovers.',
    impact: 5,
    ease: 4,
    owner: 'Operations director',
    dueDate: '2026-09-01',
    status: 'in_progress',
  },
  {
    id: 'act-6',
    title: 'Push Learning Locker sleep content to amber cohorts',
    description: 'Light-touch nudge: targeted sleep and recovery content for teams trending up but not yet red.',
    impact: 2,
    ease: 5,
    owner: 'Wellbeing partner',
    dueDate: '2026-09-05',
    status: 'done',
  },
];

export const ACTIONS_ARE_EXAMPLES =
  'These are illustrative examples of the impact-versus-ease framing, not live actions. Generating, assigning and closing real actions is tracked separately (PEAK-179).';
